import * as React from 'react';

import { useHistory } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import EditIcon from '@material-ui/icons/Edit';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import { PAGE_MENU, PAGE_ROUTE } from '../../constants';
import API from '../../services/api';
import Copyright from '../../components/copyright';
import CustomGridContainer from '../../components/custom/gridcontainer';

import useStyles from './styles';

const logo = process.env.PUBLIC_URL + '/assets/logos/logo.svg';

export default function Dashboard({ children, drawer, ...props }) {
  const history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  function getName() {
    try {
      return String(API.encryptedSessionStorage.getItem('name', API.encryptedSessionStorage.getTokenData().uid)).split(' ')[0];
    } catch {
      return 'Unauthorized user';
    }
  }

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    setOpen(!open);
  };

  function handleExitClick(event) {
    event.preventDefault();
    API.signOut()
      .then(() => {
        history.push(PAGE_ROUTE.SIGNIN);
      })
      .catch((error) => {
        console.log(error.toString());
      });
  }

  function handleClickEdit(event) {
    event.preventDefault();
    const id = Number(API.encryptedSessionStorage.getItem('id', API.encryptedSessionStorage.getTokenData().uid));

    history.push(`${PAGE_ROUTE.USERS_UPDATE}/${id}`);
  }

  return (
    <div className={classes.root}>
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton edge="start" color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} className={clsx(classes.menuButton, open && classes.menuButtonHidden)}>
            <MenuIcon />
          </IconButton>
          <CustomGridContainer container alignItems="center" justifyContent="center">
            <Grid item>
              <img className={classes.logo} src={logo} alt="Logo" />
            </Grid>
            <Grid item>
              <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                Banco Mais
              </Typography>
            </Grid>
          </CustomGridContainer>
          <Typography component="h6" variant="h6" color="inherit">
            {getName()}
          </Typography>

          <Tooltip title={'Editar perfil'}>
            <IconButton color="inherit" onClick={handleClickEdit}>
              <EditIcon />
            </IconButton>
          </Tooltip>

          {/*
          <IconButton color="inherit">
            <Badge badgeContent={4} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          */}
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</IconButton>
        </div>
        <List>
          {drawer}
          <Divider />
          <ListItem button onClick={handleExitClick}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary={PAGE_MENU.EXIT} />
          </ListItem>
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {children}
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
}
